import {
  trigger,
  style,
  animate,
  transition,
  query,
  group,
  animateChild,
  stagger,
} from '@angular/animations';

// Beziers based on: https://material.io/design/motion/speed.html#easing
export const standardEasing = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
export const decelerateEasing = 'cubic-bezier(0.0, 0.0, 0.2, 1)';
export const accelerateEasing = 'cubic-bezier(0.4, 0.0, 1, 1)';

export const listAnimations = trigger('listAnimationStagger', [
  transition('* => *', [
    // each time the binding value changes
    query(':leave', [stagger(100, [animate(`0.3s ${standardEasing}`, style({ opacity: 0 }))])], {
      optional: true,
    }),
    query(
      ':enter',
      [
        style({ opacity: 0 }),
        stagger(100, [animate(`0.22s ${standardEasing}`, style({ opacity: 1 }))]),
      ],
      { optional: true },
    ),
  ]),
]);

export const elementAnimations = trigger('elementAnimationFade', [
  transition('* => *', [
    // each time the binding value changes
    query(':leave', [stagger(100, [animate(`0.3s ${standardEasing}`, style({ opacity: 0 }))])], {
      optional: true,
    }),
    query(
      ':enter',
      [style({ opacity: 0 }), animate(`0.22s ${standardEasing}`, style({ opacity: 1 }))],
      { optional: true },
    ),
  ]),
]);

export const routeAnimations = trigger('routeAnimations', [
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(
        ':enter',
        [
          style({
            opacity: 0,
            position: 'absolute',
            width: '100%',
            height: '100%',
          }),
          animate(`0.3s ${standardEasing}`, style({ opacity: 1 })),
        ],
        { optional: true },
      ),
      query(
        ':leave',
        [
          style({
            opacity: 1,
            position: 'absolute',
            width: '100%',
            height: '100%',
          }),
          animate(`0.22s ${standardEasing}`, style({ opacity: 0 })),
        ],
        { optional: true },
      ),
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),
]);
